module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui three top attached steps"
  }, [_c('div', {
    staticClass: "step",
    class: [{
      active: _vm.step == 1
    }, {
      completed: _vm.step > 1
    }]
  }, [_c('i', {
    staticClass: "truck icon"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: [{
      active: _vm.step == 2
    }, {
      disabled: _vm.step < 2
    }, {
      completed: _vm.step > 2
    }]
  }, [_c('i', {
    staticClass: "payment icon"
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: [{
      active: _vm.step == 3
    }, {
      disabled: _vm.step < 3
    }, {
      completed: _vm.confirmed > 2
    }]
  }, [_c('i', {
    staticClass: "info icon"
  }), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Pasūtījuma informācija")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Norādi piegādes adresi un datumu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Apmaksa")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Izvēlies apmaksas veidu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Apstiprinājums")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Pārbaudi pasūtījuma detaļas")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25ebfda8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartSteps.vue
// module id = 331
// module chunks = 1